import { useEffect } from "react";
import { getPageMetadata, pageMetadata, siteUrl } from "../data/page-metadata";
import { localizedPath } from "../i18n/language";
import useLanguage from "../i18n/useLanguage";

export default function PageMetadata() {
  const { basePath, language } = useLanguage();
  useEffect(() => {
    const route = pageMetadata[basePath] ? basePath : "/";
    const metadata = getPageMetadata(route, language);
    const url = siteUrl + localizedPath(route, language);
    document.title = metadata.title;
    const values = [
      ["name", "description", metadata.description],
      ["property", "og:title", metadata.title],
      ["property", "og:description", metadata.description],
      ["property", "og:url", url],
      ["property", "og:locale", language === "en" ? "en_US" : "id_ID"],
    ];
    values.forEach(([attribute, key, content]) => {
      let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!tag) { tag = document.createElement("meta"); tag.setAttribute(attribute, key); document.head.appendChild(tag); }
      tag.content = content;
    });
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = url;
    ["id", "en", "x-default"].forEach(code => {
      let link = document.head.querySelector(`link[rel="alternate"][hreflang="${code}"]`);
      if (!link) { link = document.createElement("link"); link.rel = "alternate"; link.hreflang = code; document.head.appendChild(link); }
      link.href = siteUrl + localizedPath(route, code === "en" ? "en" : "id");
    });
  }, [basePath, language]);
  return null;
}
